// ─────────────────────────────────────────────────────────────────────────────
// chatExport — turns a chat conversation into a markdown file the user can
// download, and parses uploaded markdown files into a chat-context payload.
// ─────────────────────────────────────────────────────────────────────────────

const ROLE_LABEL = {
  user: '🧑 User',
  assistant: '🤖 AI',
  tool: '🛠️ Tool',
}

export function buildChatMarkdown({ messages, title, sessionDate, department, reportLabel }) {
  const lines = []
  lines.push(`# ${title || 'Percakapan Chat AI'}`)
  if (department || reportLabel || sessionDate) {
    lines.push('')
    if (department)  lines.push(`- **Departemen:** ${department}`)
    if (reportLabel) lines.push(`- **Laporan:** ${reportLabel}`)
    if (sessionDate) lines.push(`- **Tanggal data:** ${sessionDate}`)
  }
  lines.push('')
  lines.push(`_Diunduh: ${new Date().toLocaleString('id-ID')}_`)
  lines.push('')
  lines.push('---')
  lines.push('')

  for (const msg of messages || []) {
    const label = ROLE_LABEL[msg.role] || msg.role
    lines.push(`## ${label}`)
    lines.push('')
    lines.push(msg.content || '')
    lines.push('')
    lines.push('---')
    lines.push('')
  }
  return lines.join('\n')
}

export function downloadChatAsMarkdown(args) {
  const md = buildChatMarkdown(args)
  const safeTitle = (args?.title || 'chat-ai')
    .replace(/[^a-z0-9-_ ]/gi, '')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase() || 'chat-ai'
  const stamp = new Date().toISOString().slice(0, 10)
  triggerDownload(`${safeTitle}-${stamp}.md`, md, 'text/markdown;charset=utf-8')
}

export function downloadReportMarkdown({ title, content }) {
  if (!content) return false
  const safe = (title || 'report')
    .replace(/[^a-z0-9-_ ]/gi, '')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase() || 'report'
  const stamp = new Date().toISOString().slice(0, 10)
  triggerDownload(`${safe}-${stamp}.md`, content, 'text/markdown;charset=utf-8')
  return true
}

export async function readMarkdownFile(file) {
  if (!file) throw new Error('File tidak ada')
  if (file.size > 2 * 1024 * 1024) {
    throw new Error('File terlalu besar (max 2MB).')
  }
  const text = await file.text()
  return {
    name: file.name,
    size: file.size,
    content: text,
  }
}

function triggerDownload(filename, text, mime) {
  const blob = new Blob([text], { type: mime })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
